var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAddPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/ic-add_photo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/ic-add_photo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,5 L14.8583333,5 L13.3333333,3.33333333 L8.33333333,3.33333333 L8.33333333,5 L12.6,5 L14.125,6.66666667 L17.5,6.66666667 L17.5,16.6666667 L4.16666667,16.6666667 L4.16666667,9.16666667 L2.5,9.16666667 L2.5,16.6666667 C2.5,17.5833333 3.25,18.3333333 4.16666667,18.3333333 L17.5,18.3333333 C18.4166667,18.3333333 19.1666667,17.5833333 19.1666667,16.6666667 L19.1666667,6.66666667 C19.1666667,5.75 18.4166667,5 17.5,5 Z M6.66666667,11.6666667 C6.66666667,13.9666667 8.53333333,15.8333333 10.8333333,15.8333333 C13.1333333,15.8333333 15,13.9666667 15,11.6666667 C15,9.36666667 13.1333333,7.5 10.8333333,7.5 C8.53333333,7.5 6.66666667,9.36666667 6.66666667,11.6666667 Z M10.8333333,9.16666667 C12.2083333,9.16666667 13.3333333,10.2916667 13.3333333,11.6666667 C13.3333333,13.0416667 12.2083333,14.1666667 10.8333333,14.1666667 C9.45833333,14.1666667 8.33333333,13.0416667 8.33333333,11.6666667 C8.33333333,10.2916667 9.45833333,9.16666667 10.8333333,9.16666667 Z M4.16666667,5 L6.66666667,5 L6.66666667,3.33333333 L4.16666667,3.33333333 L4.16666667,0.833333333 L2.5,0.833333333 L2.5,3.33333333 L3.90798505e-14,3.33333333 L3.90798505e-14,5 L2.5,5 L2.5,7.5 L4.16666667,7.5 L4.16666667,5 Z",
    id: "Shape",
    fill: "#000000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPhoto);
export default __webpack_public_path__ + "static/media/ic-add_photo.4f8dd101.svg";
export { ForwardRef as ReactComponent };